import { FroppioLoader } from "./FroppioLoader";

interface LoadingSpinnerProps {
  fullScreen?: boolean;
  message?: string;
}

export function LoadingSpinner({
  fullScreen = false,
  message,
}: LoadingSpinnerProps) {
  if (fullScreen) {
    return (
      <div role="status" aria-label="Loading Froppio" className="flex min-h-dvh items-center justify-center bg-background">
        <FroppioLoader className="size-32" />
      </div>
    );
  }

  return (
    <div role="status" className="flex flex-col items-center justify-center gap-3 rounded-[20px] border border-dashed border-border bg-card px-5 py-7">
      <FroppioLoader className="size-14" />
      {message ? <p className="text-sm text-muted-foreground">{message}</p> : <span className="sr-only">Loading...</span>}
    </div>
  );
}
